export function monthIndexFromYearMonth(ym: string): number {
  const [y, m] = ym.split('-').map(Number);
  return y * 12 + (m - 1);
}

/** Alle YYYY-MM-Werte, die ein Datumsbereich (inkl.) abdeckt. */
export function yearMonthsInRange(fromYmd: string, toYmd: string): string[] {
  const fromYm = fromYmd.slice(0, 7);
  const toYm = toYmd.slice(0, 7);
  if (!/^\d{4}-\d{2}$/.test(fromYm) || !/^\d{4}-\d{2}$/.test(toYm) || fromYm > toYm) {
    return [];
  }
  const out: string[] = [];
  let idx = monthIndexFromYearMonth(fromYm);
  const endIdx = monthIndexFromYearMonth(toYm);
  while (idx <= endIdx) {
    const y = Math.floor(idx / 12);
    const m = (idx % 12) + 1;
    out.push(`${y}-${String(m).padStart(2, '0')}`);
    idx += 1;
  }
  return out;
}

export function yearMonthFromBounds(fromYmd: string): string {
  return fromYmd.slice(0, 7);
}

export function yearMonthFromYmd(ymd: string): string {
  return ymd.slice(0, 7);
}

export function lastDayOfMonth(yearMonth: string): number {
  const [y, m] = yearMonth.split('-').map(Number);
  if (!Number.isFinite(y) || !Number.isFinite(m) || m < 1 || m > 12) return 31;
  return new Date(Date.UTC(y, m, 0)).getUTCDate();
}

/** Kalendertag innerhalb eines Monats (Tag wird auf den letzten des Monats begrenzt). */
export function bookingDateInMonth(yearMonth: string, dayOfMonth: number): string {
  const last = lastDayOfMonth(yearMonth);
  const day = Math.min(Math.max(1, Math.floor(dayOfMonth)), last);
  return `${yearMonth}-${String(day).padStart(2, '0')}`;
}

export function defaultBookingDateForMonth(yearMonth: string, dayOfMonth = 15): string {
  return bookingDateInMonth(yearMonth, dayOfMonth);
}

/** Sinnvolles Standarddatum im sichtbaren Abrechnungsmonat. */
export function defaultBookingDateInPeriod(fromYmd: string, dayOfMonth = 15): string {
  const yearMonth = yearMonthFromBounds(fromYmd);
  const today = new Date().toISOString().slice(0, 10);
  if (yearMonthFromYmd(today) === yearMonth) return today;
  return defaultBookingDateForMonth(yearMonth, dayOfMonth);
}

export function formatPayrollAdjustmentDate(ymd: string): string {
  if (!ymd || ymd.length < 10) return '—';
  const [y, m, d] = ymd.slice(0, 10).split('-');
  return `${d}.${m}.${y}`;
}

export function formatDayOfMonthLabel(day: number): string {
  return `${day}.`;
}

export function yearMonthLabel(ym: string): string {
  const [y, m] = ym.split('-').map(Number);
  if (!Number.isFinite(y) || !Number.isFinite(m) || m < 1 || m > 12) return ym;
  const d = new Date(Date.UTC(y, m - 1, 1));
  return d.toLocaleDateString('de-DE', { month: 'long', year: 'numeric', timeZone: 'UTC' });
}

export function exitYearMonthFromDate(endDate: string | null | undefined): string | null {
  if (!endDate) return null;
  const ymd = endDate.slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return null;
  return ymd.slice(0, 7);
}
